import { lazy, Suspense } from "react";
import { useMemberRoles } from "@/integrations/fc/auth0";

const Actions = lazy(() => import("@/components/site/EventCardActions").then((module) => ({ default: module.EventCardActions })));

export function LazyEventCardActions(props: { slug: string; title: string; photo?: boolean }) {
  const { isAdmin } = useMemberRoles();
  if (!isAdmin) return null;
  return <Suspense fallback={null}><Actions {...props} /></Suspense>;
}